export default __webpack_public_path__ + "static/equality-b1a26a4df1ef6af86112d9420d2ad770.png";